<script lang="ts">
const components = {
  'jps-curation-text': defineAsyncComponent(
    () => import('./parts/text/CurationText.vue'),
  ),
  'jps-curation-list': defineAsyncComponent(
    () => import('./parts/list/CurationList.vue'),
  ),
  'jps-curation-search-box': defineAsyncComponent(
    () => import('./parts/search-box/CurationSearchBox.vue'),
  ),
  'jps-curation-section': defineAsyncComponent(
    () => import('./parts/section/CurationSection.vue'),
  ),
  'jps-curation-image': defineAsyncComponent(
    () => import('./parts/image/CurationImage.vue'),
  ),
  'jps-curation-subpage-list': defineAsyncComponent(
    () => import('./parts/subpage-list/CurationSubpageList.vue'),
  ),
  'jps-curation-timeline': defineAsyncComponent(
    () => import('./parts/timeline/CurationTimeline.vue'),
  ),
  'jps-curation-image-annotation': defineAsyncComponent(
    () => import('./parts/image-annotation/CurationImageAnnotation.vue'),
  ),
  'jps-curation-index': defineAsyncComponent(
    () => import('./parts/index/CurationIndex.vue'),
  ),
  'jps-curation-iframe': defineAsyncComponent(
    () => import('./parts/iframe/CurationIframe.vue'),
  ),
  'jps-curation-tab': defineAsyncComponent(
    () => import('./parts/tab/CurationTab.vue'),
  ),
}
export default {
  props: {
    curation: {
      type: Object,
      required: false,
    },
    parts: {
      type: Array,
      required: false,
    },
  },
  setup(props: { curation?: Curation; parts?: CurationPartDefinition[] }) {
    return () => {
      return h(
        'div',
        {
          class: 'curation-body',
        },
        props.parts
          ? props.parts.map(part => {
              return components[part.type]
                ? h(components[part.type], {
                    curation: props.curation,
                    def: part,
                    class: part.styleClass,
                    key: part.cpid,
                  })
                : h('div', {}, part.type)
            })
          : [],
      )
    }
  },
}
</script>
